import styled from 'styled-components';
import { useTheme } from '@/context/ThemeContext';
import GripWallpaper from '@/assets/grip-wallpaper-opt.jpg';
import DarkBg from '@/images/backgroundimages/dark_background.png';

const Background = styled.div<{ $isDark: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: -1;
  background-image: url(${({ $isDark }) => ($isDark ? DarkBg : GripWallpaper)});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-attachment: fixed;
  transition: opacity 0.5s ease-in-out;
`;

export const BackgroundWrapper = () => {
  const { mode } = useTheme();

  return <Background $isDark={mode === 'dark'} />;
};
